import Api from '../services/api';
import apiURLBuilder from '../core/apiURLBuilder';
import actionTypes from 'constants/actionTypes';
import { actions as formActions } from 'react-redux-form';
import { ROBO } from 'constants/userProfile';

const setPromoCodeErrorRobo = () => ({
    type: actionTypes.SET_PROMO_CODE_ERROR_ROBO,
});

const resetPromoCodeErrorRobo = () => ({
    type: actionTypes.RESET_PROMO_CODE_ERROR_ROBO,
});

const getPromotionService = (dispatch, investmentType, codeId, creditCardCheck, language, callback) => {
    let stCodId = '';
    if (typeof codeId !== 'undefined') {
        stCodId = codeId.toUpperCase();
    }
    const isOpenCredit = stCodId === 'OPENCREDIT' || creditCardCheck;
    const saveRequestData = {
        header: {},
        query: {
            isOpenCredit,
            promotionalCode: codeId,
            language,
        },
    };

    // Check product action when updating this endpoint
    return Api.get(apiURLBuilder.getURL('getPromotionalCodes'), saveRequestData).then(
        response => {
            if (response.body) {
                if (response.body.status === 'OK') {
                    const isRoboInvesmentType = investmentType === ROBO;
                    const isRoboPromoCode = response.body.promotionalCode.isRoboPromoCode;
                    const isValidPromoCode = isRoboInvesmentType === isRoboPromoCode;
                    const data = {
                        productsDescription: response.body.productsDescription,
                        products: response.body.products,
                    };

                    dispatch(formActions.change('userProfile.creditCardOffer_accepted', isOpenCredit));
                    dispatch(formActions.change('userProfile.product', response.body.productCode));
                    response.body.promotionalCode &&
                        dispatch({
                            type: actionTypes.GET_PROMO_CODE_RESULT,
                            data: response.body,
                        });

                    if (isValidPromoCode) {
                        const onboardingType = response.body.onboardingType;
                        onboardingType && dispatch(formActions.change('userProfile.onboardingType', onboardingType));
                        dispatch({
                            type: actionTypes.CLEAR_PRODUCTS,
                        });
                        dispatch({
                            type: actionTypes.LOAD_PRODUCTS,
                            data,
                        });
                    }

                    if (isRoboInvesmentType && !isRoboPromoCode) {
                        dispatch(setPromoCodeErrorRobo());
                    }

                    if (callback !== null) callback(true);
                } else {
                    dispatch({
                        type: actionTypes.CLEAR_PROMO_CODE_RESULT,
                    });

                    if (response.body.errors[100]) {
                        dispatch({
                            type: actionTypes.SET_PROMO_CODE_EXPIRED,
                            data: response.body,
                        });
                    }

                    if (callback !== null) callback(false, response);
                }
            }
        },
        error => {
            if (callback !== null) callback(false, error);
        }
    );
};

const getPromotion =
    (codeId, language = 'es', callback = null) =>
    (dispatch, getState) => {
        const creditCardCheck = getState().userProfile.creditCardOffer_accepted;
        const investmentType = getState().userProfile.investmentType;

        return getPromotionService(dispatch, investmentType, codeId, creditCardCheck, language, callback);
    };

const clearPromotion = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_PROMO_CODE_RESULT,
        });
    };
};

const setPromoCode = data => {
    return dispatch => {
        dispatch({
            type: actionTypes.GET_PROMO_CODE_RESULT,
            data,
        });
    };
};

export default {
    getPromotion,
    clearPromotion,
    setPromoCode,
    resetPromoCodeErrorRobo,
};
